var map = {
	"./back1.jpeg": "bcfe",
	"./back2.jpeg": "dce8",
	"./back3.jpeg": "489e",
	"./backgroud1.jpeg": "0a48",
	"./footer-bg.png": "4ef4",
	"./icon-menu.png": "0e8e",
	"./logo.png": "cf05",
	"./menu.svg": "36be",
	"./menupc.svg": "9746",
	"./p1.jpg": "9e75",
	"./p2.jpg": "0c3b",
	"./p3.jpg": "d982"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";